import React from "react";
import styled from "styled-components";
import Icon from "../../../../src/icons/Icon";
import colors from "../../../utils/colors";
import { rem } from "polished";

const TH = styled.th`
  &.sortable {
    cursor: pointer;
  }

  svg {
    vertical-align: top;
    padding-top: 1px;
    padding-left: 0.5rem;
  }
`;

const TableHeader = props => {
  const { items, onSort, sortable } = props;
  const onSortClick = item => {
    if (sortable) {
      onSort(item);
    }
  };

  return (
    <tr>
      {items.map(item => (
        <TH onClick={() => onSortClick(item)} key={item.name} className={sortable && "sortable"}>
          {item.uiName}
          {item.sort === "asc" && (
            <Icon icon="#sort-down" width={rem("11px")} height={rem("11px")} fill={colors.GRAY} />
          )}
          {item.sort === "desc" && (
            <Icon icon="#sort-up" width={rem("11px")} height={rem("11px")} fill={colors.GRAY} />
          )}
        </TH>
      ))}
    </tr>
  );
};

export default TableHeader;



// WEBPACK FOOTER //
// ./src/modules/common/components/TableHeader.js